export class TransitionIntent {
    constructor(router, data = {}) {
        this.router = router;
        this.data = data;
    }
}
//# sourceMappingURL=transition-intent.js.map